export default function AboutSection() {
  const stats = [
    { value: '50K+', label: 'Community Searches' },
    { value: '100+', label: 'Shopping Guides' },
    { value: '30+', label: 'In-Depth Articles' },
    { value: '14', label: 'Product Categories' },
  ];

  const benefits = [
    { title: 'Save Shopping Time', desc: 'Find products in seconds instead of hours with our organized spreadsheet system.', icon: 'ri-time-line' },
    { title: 'Organized Categories', desc: 'Browse through 14 carefully curated product categories for effortless discovery.', icon: 'ri-layout-grid-line' },
    { title: 'Easy Comparison', desc: 'Compare products side by side with structured data that makes decisions simple.', icon: 'ri-scales-3-line' },
    { title: 'Beginner-Friendly', desc: 'No technical skills needed. Our guides walk you through every step of the way.', icon: 'ri-emotion-happy-line' },
    { title: 'Updated Product Lists', desc: 'Fresh data and new products added daily so you never miss a trending item.', icon: 'ri-loop-left-line' },
    { title: 'Safer Buying Decisions', desc: 'Safety tips and verified information help you shop with confidence every time.', icon: 'ri-shield-star-line' },
  ];

  return (
    <section id="about" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-500">About</span>
            <h2 className="mt-3 text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              What Is <span className="text-primary-500">Vigorbuy Spreadsheet</span>?
            </h2>
            <p className="mt-5 text-base text-foreground-600 leading-relaxed max-w-lg">
              Vigorbuy Spreadsheet is a structured product discovery system that helps users find products faster, compare options, and organize shopping information efficiently.
            </p>
            <p className="mt-3 text-base text-foreground-600 leading-relaxed max-w-lg">
              Whether you are looking for fashion, sneakers, accessories, or trending products, Vigorbuy Spreadsheet makes product research simple and intuitive.
            </p>

            <div className="mt-8 grid grid-cols-4 gap-0 border border-background-200/70 rounded-xl overflow-hidden">
              {stats.map((stat, idx) => (
                <div
                  key={idx}
                  className={`flex flex-col items-center justify-center py-5 px-3 ${
                    idx < 3 ? 'border-r border-background-200/70' : ''
                  }`}
                >
                  <span className="text-xl md:text-2xl font-heading font-bold text-accent-500">{stat.value}</span>
                  <span className="mt-1 text-xs text-foreground-500 text-center leading-tight">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-accent-100/60 rounded-3xl -rotate-3"></div>
            <div className="relative bg-background-50 rounded-3xl border border-background-200/50 p-8 md:p-10">
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-6">
                Why Thousands of Users Prefer Vigorbuy Spreadsheet
              </h3>
              <div className="grid grid-cols-1 gap-4">
                {benefits.map((benefit, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                      <i className={`${benefit.icon} text-base`}></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{benefit.title}</p>
                      <p className="text-xs text-foreground-500 mt-0.5 leading-relaxed">{benefit.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}